import { useQuery } from "@tanstack/react-query";
import { dashboardService } from "@/services/dashboardService";

export const dashboardKeys = {
  all: ["dashboard"] as const,
  metrics: (slug: string) => [...dashboardKeys.all, "metrics", slug] as const,
  funnel: (slug: string, dateFrom: string, dateTo: string) => [...dashboardKeys.all, "funnel", slug, dateFrom, dateTo] as const,
  contacts: (slug: string, dateFrom: string, dateTo: string) => [...dashboardKeys.all, "contacts", slug, dateFrom, dateTo] as const,
  opportunities: (slug: string) => [...dashboardKeys.all, "opportunities", slug] as const,
};

export function useGetDashboardMetrics(slug: string | undefined) {
  return useQuery({
    queryKey: dashboardKeys.metrics(slug || ""),
    queryFn: async () => {
      if (!slug) throw new Error("No slug provided");
      const response = await dashboardService.getMetrics(slug);
      return response; // No .data needed
    },
    enabled: !!slug,
    staleTime: 1000 * 60 * 5, // 5 minutos cache
  });
}

export function useGetSalesFunnel(slug: string | undefined, dateFrom: string, dateTo: string) {
  return useQuery({
    queryKey: dashboardKeys.funnel(slug || "", dateFrom, dateTo),
    queryFn: async () => {
      if (!slug) throw new Error("No slug provided");
      const response = await dashboardService.getSalesFunnel(
        slug,
        dateFrom,
        dateTo
      );
      return response; // No .data needed
    },
    enabled: !!slug,
    staleTime: 1000 * 60 * 5,
  });
}

export function useGetContactsReport(slug: string | undefined, dateFrom: string, dateTo: string) {
  return useQuery({
    queryKey: dashboardKeys.contacts(slug || "", dateFrom, dateTo),
    queryFn: async () => {
      if (!slug) throw new Error("No slug provided");
      const response = await dashboardService.getContactsReport(
        slug,
        dateFrom,
        dateTo
      );
      return response; // No .data needed
    },
    enabled: !!slug,
    staleTime: 1000 * 60 * 5,
  });
}

export function useGetDashboardOpportunities(slug: string | undefined) {
  return useQuery({
    queryKey: dashboardKeys.opportunities(slug || ""),
    queryFn: async () => {
      if (!slug) throw new Error("No slug provided");
      const response = await dashboardService.getOpportunities(slug);
      return response; // No .data needed
    },
    enabled: !!slug,
    staleTime: 1000 * 60 * 5,
  });
}
